const middleware = {}

middleware['mockInterviewsEnabled'] = require('../middleware/mockInterviewsEnabled.js')
middleware['mockInterviewsEnabled'] = middleware['mockInterviewsEnabled'].default || middleware['mockInterviewsEnabled']

export default middleware
